import { C, R } from "@/brand/tokens";

const TONES = {
  brass: { background: C.accentMetal, color: C.bgDark },
  outline: { background: "transparent", color: C.accentMetal, border: `1px solid ${C.brassLine}` },
  teal: { background: C.accentFunctional, color: C.textOnDark },
  blue: { background: C.surfacePrimary, color: C.textOnDark },
  light: { background: "rgba(244,241,234,0.12)", color: C.textOnDark, border: `1px solid ${C.brassLine}` },
};

/** Pill6 — small metadata tag, full pill radius. */
export function Pill6({ children, tone = "brass", testId, className = "" }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center font-inter text-[9.5px] uppercase font-bold px-3 py-1 whitespace-nowrap ${className}`}
      style={{ ...TONES[tone], borderRadius: R.pill, letterSpacing: "0.16em" }}
    >
      {children}
    </span>
  );
}
